import { render, staticRenderFns } from "./ReservationUpdated.vue?vue&type=template&id=5b382c50"
import script from "./ReservationUpdated.vue?vue&type=script&lang=js"
export * from "./ReservationUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports